import React, { useEffect, useRef, useState } from 'react';
import { Flex, TextInput, Text, Button } from '@mantine/core';
import { ReactComponent as ArrowRight } from '../../../assets/images/icons/arrow_right.svg';
import { useProductQuiz } from '../ProductQuizContext';
import { quizQuestionPage } from '../../../lib/analytics/events';
import { useTranslation } from 'react-i18next';

export const QuestionEmail: React.FC = () => {
  const { t } = useTranslation();
  useEffect(() => {
    quizQuestionPage.quizEnterEmailPageEntered();
  }, []);

  const { quizAnswers, setQuizAnswers } = useProductQuiz();

  const emailRef = useRef<HTMLInputElement>(null);
  const [email, setEmail] = useState<string>(quizAnswers.email ?? '');

  return (
    <>
      <Flex
        mt={40}
        style={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'flex-start',
          gap: 16,
          alignSelf: 'stretch',
        }}
      >
        <Text
          size={28}
          weight={700}
          style={{
            lineHeight: '100%',
            letterSpacing: '-1.12px',
          }}
        >
          {t('enter_email_to_receive_updates_from_fi')}
        </Text>
      </Flex>
      <Flex
        style={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'flex-start',
          gap: 16,
          alignSelf: 'stretch',
        }}
      >
        <TextInput
          autoFocus
          ref={emailRef}
          type={'email'}
          placeholder="fi@gmail.com"
          w={'100%'}
          radius="xl"
          sx={{ input: { fontSize: 16, height: 56, paddingLeft: '2em', paddingRight: 10, enterKeyHint: 'next' } }}
          value={email}
          onChange={(e) => setEmail(e.currentTarget.value)}
          rightSection={
            <Flex
              align={'center'}
              sx={(theme) => ({
                marginRight: '2em',
                color: email.trim() ? 'black' : theme.colors['background-light-tertiary'],
              })}
            >
              <ArrowRight
                onClick={() => {
                  if (email.trim()) {
                    quizQuestionPage.quizEnterEmailNext(email);
                    setQuizAnswers({ ...quizAnswers, email });
                  }
                }}
              />
            </Flex>
          }
          onKeyDown={(e) => {
            if (e.key === 'Enter') {
              if (email.trim()) {
                quizQuestionPage.quizEnterEmailNext(email);
                setQuizAnswers({ ...quizAnswers, email });
              }
            }
          }}
        />
        <Button
          style={{ alignSelf: 'center', color: '#FFF', background: 'transparent' }}
          onClick={() => {
            quizQuestionPage.quizEnterEmailNext('');
            setEmail('');
            setQuizAnswers({ ...quizAnswers, email: '' });
          }}
        >
          {t('no_thanks')}
        </Button>
      </Flex>
    </>
  );
};
